var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49,
    height: 45,
    fill: "none",
    customFrame: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M10 17.5C10 7.83502 17.835 0 27.5 0C37.165 0 45 7.83502 45 17.5C45 21.7925 43.4546 25.724 40.8898 28.7684L48.5607 36.4393C49.1464 37.0251 49.1464 37.9749 48.5607 38.5607C47.9749 39.1464 47.0251 39.1464 46.4393 38.5607L38.7684 30.8898C35.724 33.4546 31.7925 35 27.5 35C26.8764 35 26.2605 34.9674 25.6538 34.9038C23.7193 38.5311 19.8979 40.9998 15.5 40.9998C12.8651 40.9998 10.4372 40.1137 8.49799 38.6231L2.56066 44.5605C1.97487 45.1462 1.02513 45.1462 0.43934 44.5605C-0.146447 43.9747 -0.146447 43.0249 0.43934 42.4391L6.37667 36.5018C4.88614 34.5626 4 32.1347 4 29.4998C4 25.1018 6.46882 21.2804 10.0962 19.3459C10.0326 18.7393 10 18.1235 10 17.5ZM27.5 3C19.4919 3 13 9.49187 13 17.5C13 25.5081 19.4919 32 27.5 32C35.5081 32 42 25.5081 42 17.5C42 9.49187 35.5081 3 27.5 3ZM34.5602 14.5602C35.1459 13.9744 35.1459 13.0246 34.5602 12.4388C33.9744 11.8531 33.0246 11.8531 32.4388 12.4388L25.498 19.3796L22.5573 16.4388C21.9715 15.8531 21.0217 15.8531 20.4359 16.4388C19.8501 17.0246 19.8501 17.9744 20.4359 18.5602L24.4374 22.5616C25.0232 23.1474 25.9729 23.1474 26.5587 22.5616L34.5602 14.5602ZM10.7165 22.4725C8.47297 24.0027 7 26.5792 7 29.4998C7 34.1942 10.8056 37.9998 15.5 37.9998C18.4205 37.9998 20.997 36.5269 22.5272 34.2834C16.8607 32.607 12.3928 28.1391 10.7165 22.4725Z",
    fill: "rgb(29,29,27)",
    fillOpacity: 0.400000006,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.ec43210820f2749e523115c04d8a0527.svg";
export { ForwardRef as ReactComponent };